import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=6c93e4d0&"
import script from "./DeleteModal.vue?vue&type=script&lang=js&"
export * from "./DeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c93e4d0')) {
      api.createRecord('6c93e4d0', component.options)
    } else {
      api.reload('6c93e4d0', component.options)
    }
    module.hot.accept("./DeleteModal.vue?vue&type=template&id=6c93e4d0&", function () {
      api.rerender('6c93e4d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/modal/DeleteModal.vue"
export default component.exports